import classNames from 'classnames';
import { ChangeEvent, FC, useCallback, useState } from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap';

import type { AppCrashedProps } from './appCrashed.connect';
import { connectAppCrashed } from './appCrashed.connect';

function onReload() {
  window.location.reload();
}
export const AppCrashedComponent: FC<AppCrashedProps> = ({ isCrashed, errorMessage, sendManualMail }) => {
  const [showDetails, setShowDetails] = useState(false);
  const [mailSent, setMailSent] = useState(false);
  const [userComment, setUserComment] = useState<string | null>(null);

  const toggleDetails = useCallback(() => {
    setShowDetails(wasShown => !wasShown);
  }, []);

  const sendMail = useCallback(() => {
    sendManualMail(errorMessage!, userComment!);
    setMailSent(true);
  }, [sendManualMail, errorMessage, userComment]);

  const onTextChange = useCallback((e: ChangeEvent<HTMLTextAreaElement>) => {
    setUserComment(e.target.value);
  }, []);

  if (!isCrashed) {
    return null;
  }
  return (
    <Modal show className="border border-danger">
      <ModalHeader>
        <ModalTitle className="text-danger" as="h3">
          An unrecoverable error has occurred
        </ModalTitle>
      </ModalHeader>

      <ModalBody>
        <p className="text-large">
          <b> You have to reload the page to resume working.</b>
        </p>
        <p className="fs-6">
          A mail containing technical details has been automatically sent to support. Providing more details about what
          happened and what you were doing would be helpful to solve the issue you experienced.
        </p>
        <textarea
          onChange={onTextChange}
          className="form-control w-100"
          rows={2}
          placeholder="Please describe what you were doing when the error happened."
        ></textarea>
        <div className="sgbs-collapse-separator sgbs-collapse-separator-centered">
          <button className="btn btn-flat-primary w-100 justify-content-center mt-2" onClick={toggleDetails}>
            <span>
              Technical details
              <i className="icon icon-sm">{showDetails ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i>
            </span>
          </button>
          <div className={classNames('collapse border w-100 bg-lvl3 mt-2 px-2 py-3', { show: showDetails })}>
            <code>{errorMessage}</code>
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        {mailSent ? (
          <p className="text-success">
            <i className="icon icon-sm">done</i>Help request has been sent successfully
          </p>
        ) : (
          <button className="btn btn-primary" disabled={userComment === null} onClick={sendMail}>
            Send help request
          </button>
        )}
        <button className="btn btn-danger" onClick={onReload}>
          Reload
        </button>
      </ModalFooter>
    </Modal>
  );
};
AppCrashedComponent.displayName = 'AppCrashedComponent';

export const AppCrashed = connectAppCrashed(AppCrashedComponent);
AppCrashed.displayName = 'AppCrashed';
